import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { EventMarketType, EventRunnerType } from "app/types/eventType";

/**
 * The BetRunnerName component displays the formatted name of a bet runner.
 * It extracts the odd and market from the bet slip and formats the name based on the market type.
 *
 * @param {Object} props - The component props.
 * @param {BetSlipType} props.betSlip - The bet slip object.
 */
const BetRunnerName = ({ betSlip }) => {
  const betSlipOdd = BetSlipHelper.getBetSlipOdd(betSlip);
  const betSlipMarket: EventMarketType | null =
    BetSlipHelper.getBetSlipMarket(betSlip);

  const formattedName = betSlipOdd?.name.replace("[", "").replace("]", "");
  // This formatting is probably not needed anymore but doesnt break anything and there might be an edge
  // case when it is needed for a certain name

  // TODO fix this together with BetSlipHelper.formatMarketName
  const playerPropsFormattedName =
    betSlipMarket?.name +
    " " +
    "(" +
    betSlipOdd?.type +
    " " +
    betSlipMarket?.handicap +
    ")";

  const renderFormattedHandicap = () => {
    // Uses formatted handicap values provided by api at runner level
    // The value to be used is returned as formattedHandicap in euro competition list fetch, and euro summarised event fetch
    // and modalFormattedValue in asian comp list fetch, asian event modal fetch , and euro event details fetch
    //
    // Not to be confused with how the asian list works....
    // asian comp list fetch returns both formattedHandicap and modalFormattedValue  :-O
    // - formattedHandicap here is without a + or - , and is displayed next to the runner with negative handicap value
    // - modalFormattedHandicap is used for displaying the actual handicap value including + or -

    const betSlipOdd: EventRunnerType | null =
      BetSlipHelper.getBetSlipOdd(betSlip);

    if (betSlipOdd?.name.includes(betSlipOdd.modalFormattedHandicap)) {
      return "";
    } else if (betSlipOdd?.modalFormattedHandicap) {
      return betSlipOdd.modalFormattedHandicap;
    } else if (betSlipOdd?.formattedHandicap) {
      return betSlipOdd.formattedHandicap;
    } else {
      return "";
    }
  };
  /**
   * Render the component.
   */
  return (
    <div>
      {BetSlipHelper.formatMarketName(
        betSlipMarket?.type,
        playerPropsFormattedName,
        formattedName
      )}
      {"\u00A0"}

      {renderFormattedHandicap()}
    </div>
  );
};

export default BetRunnerName;
